import axios from 'axios';
// import { logoutUser } from '@/api/requests';
import store from '../store';
import router from '../router';

let url = window.location.origin;

if (url === 'http://localhost:8080') {
  url = 'http://localhost:3000';
}

const axiosInstance = axios.create({
  baseURL: `${url}/api`
});

axiosInstance.interceptors.request.use(
  config => {
    if (store.state.users.token) {
      config.headers = {
        'Authorization': `Bearer ${store.state.users.token}`,
        'Accept': 'application/json',
      }
    }

    return config
  }, error => Promise.reject(error))

axiosInstance.defaults.params = {};
axiosInstance.interceptors.response.use(response => response, error => {
  if (error.response) {
    if (error.response.status === 401) {
      store.dispatch('users/logout');
      localStorage.clear();
      router.push('/');
    }
  }

  return Promise.reject(error);
});

export default axiosInstance